import api from ".";
import cookiesModifier from "../utils/cookies";

import { INotificationQualifiedUsers, ISaveCustomNotification } from "../types/custom_notifications";


export const getCustomNotifications = async () => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`/custom-notifications`);
        return res.data.data;
    } catch (error) {
        throw error;
    }
};

export const saveCustomNotification = async (data: ISaveCustomNotification) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`/custom-notifications`, data);
        return res.status;
    } catch (error) {
        throw error;
    }
};

export const deleteCustomNotification = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`/custom-notifications/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
};

export const testCustomNotification = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`/custom-notifications/test/${id}`);
        return res.data;
    } catch (error) {
        throw error;
    }
};

export const sendCustomNotification = async (id: number, data: INotificationQualifiedUsers[]) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`/custom-notifications/send/${id}`, data);
        return res.data;
    } catch (error) {
        throw error;
    }
}